<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center "
    style="z-index: 500000;"
  >
    <!--
      Background overlay, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
      Modal panel, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Select Google Business to sync reviews
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div v-if="isLoading">
        <Spinner />
      </div>
      <div v-else class="sm:ml-4 mt-4">
        <fieldset>
          <div
            class="mt-4 divide-y divide-gray-200 border-b border-t border-gray-200"
          >
            <div
              class="relative flex items-start py-4"
              v-for="(location, index) of locations"
              :key="index"
            >
              <div class="min-w-0 flex-1 text-sm leading-6">
                <label
                  :for="location.name"
                  class="select-none font-medium text-gray-900"
                  >{{ location.title }}</label
                >
              </div>
              <div class="ml-3 flex h-6 items-center">
                <input
                  :id="location.name"
                  v-model="selectedLocationId"
                  name="location"
                  type="radio"
                  :value="location.name"
                  class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <div class="Polaris-ButtonGroup">
          <div class="Polaris-ButtonGroup__Item">
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
              type="button"
              @click="close"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Cancel</span
              >
            </button>
          </div>
          <div class="Polaris-ButtonGroup__Item" v-if="!isLoading">
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
              type="button"
              @click="selectLocation"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Select</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from "lodash-es";
import Spinner from "vue-simple-spinner";

export default {
  components: { Spinner },
  props: { googleAccount: { type: Object } },
  data() {
    return {
      isLoading: false,
      locations: [],
      selectedLocationId: ""
    };
  },
  created() {
    this.selectedLocationId = this.googleAccount.locationId;
    this.init();
  },
  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getGoogleAccounts").then(response => {
        this.locations = response.locations;
        this.isLoading = false;
      });
    },
    close() {
      this.$emit("close");
    },
    selectLocation() {
      const selectedLocation = find(this.locations, {
        name: this.selectedLocationId
      });
      this.$emit("selected", {
        locationId: selectedLocation.name,
        locationName: selectedLocation.title,
        newReviewUri: selectedLocation.metadata.newReviewUri
      });
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped></style>
